import { V as GTM_CUSTOMER_INTERACTION_EVENT, C as CART_UPDATE_EVENT, J as JS_PREFIX, h, t as translate, D as DECATHLON_NAMESPACE, H as HIDE_ONLY_N_LEFT_TAG, i as PRODUCT_BULKY_TAG, W as NO_FREE_RETURNS, P as PRODUCT_TILE_ADD_TO_CART_SUCCESS_EVENT, E } from './built-constants-439d5572.js';
import { b as getProduct, g as getCart } from './built-ajax-api-4ab76389.js';
import { c as cartEventEmitter } from './built-cart-event-emitter-def8079a.js';
import './built-env-utils-ed419642.js';
import './built-config-a65ae98c.js';
import { v, p } from './built-clsx.m-cb13ff27.js';
import './built-init-1bb12f92.js';
import './built-loglevel-42c63e3e.js';
import { f as formatPriceSingle, a as formatPriceSecondary, P as PRODUCT_PAGE_COPY } from './built-price-format-dc3d77ee.js';
import { v as variantHasSufficientQuantity } from './built-error-message-utilities-4ca13134.js';
import './built-on-add-to-cart-59888dcc.js';
import { F as FreeShippingIndicator, s as shopifyImgSize, C as CartSubtotal, i as init$1 } from './built-shopify-image-size-395e302a.js';
import './built-make-request-bc649a18.js';
import './built-element-utils-09877efc.js';
import { b as getUrlVariant } from './built-get-url-variant-a647ef33.js';
import './built-utilities-e07c7454.js';
import './built-fetch-stores-17ca97d2.js';
import './built-js.cookie-7baadf9c.js';
import './built-index-750f2ec8.js';
import './built-services-8840a941.js';

/**
 * Sends event to Google Analytics
 * @param {Object} params
 * @param {string} params.category The name assigned to the group of similar events
 * @param {string} params.action The name assigned to the type of event you want to track
 * @param {string} params.label The label of the event (e.g. "Close Drawer X")
 */

const sendGTMCustomerInteraction = ({
  category,
  action,
  label
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: GTM_CUSTOMER_INTERACTION_EVENT,
    category,
    action,
    label
  });
};

/** @typedef {import('../cart').Cart} Cart */

/**
 * Module-specific constants
 */

const DATA_DRAWER_ID = 'data-drawer-id="post-add-to-cart-drawer"';
const DATA_DRAWER_ACTION = 'data-drawer-action="close"';
const DRAWER_CLOSE_BUTTON_SELECTOR = "." + JS_PREFIX + "Drawer-toggle[" + DATA_DRAWER_ID + "][" + DATA_DRAWER_ACTION + "]";
const DRAWER_CLOSE_OVERLAY_SELECTOR = "." + JS_PREFIX + "Drawer-overlay[" + DATA_DRAWER_ID + "][" + DATA_DRAWER_ACTION + "]";
const PRODUCT_TILE_LINK_SELECTOR = "." + JS_PREFIX + "PostAddToCart-productTiles ." + JS_PREFIX + "ProductTile-link";
const VIEW_CART_SELECTOR = "." + JS_PREFIX + "PostAddToCart-viewCart";
const CHECKOUT_SELECTOR = "." + JS_PREFIX + "PostAddToCart-checkout";
const CLICK_EVENT = 'click';
const GTM_LABEL_CLOSE_DRAWER_X = 'Close Drawer X';
const GTM_LABEL_EXIT_DRAWER_OUTSIDE = 'Exit Drawer Outside';
const GTM_LABEL_PRODUCT = 'Product';
const GTM_LABEL_CHECK_OUT = 'Check Out';
const GTM_LABEL_VIEW_CART = 'View Cart';
/**
 * AJAX cart total price
 * @type {string}
 * @see https://help.shopify.com/en/themes/liquid/objects/cart#cart-total_price
 */

let cartTotalPrice;
/**
 * Sends Post Add to Cart specific event to Google Tag Manager
 * @param {string} label The label of the event (e.g. "Close Drawer X")
 */

const sendPostAddToCartGTMEvent = label => {
  sendGTMCustomerInteraction({
    category: 'Post Add To Cart',
    action: CLICK_EVENT,
    label: label + " | " + cartTotalPrice
  });
};
/**
 * Handle AJAX `/cart.js` JSON
 * Sets cartTotalPrice value
 */


const addCartListener = () => {
  /** @param {Cart | undefined} cart */
  const eventHandler = cart => {
    if (cart) cartTotalPrice = formatPriceSingle(cart.total_price.toString());
  };

  cartEventEmitter.on(CART_UPDATE_EVENT, eventHandler);
};
/**
 * Handle button Close event
 */


const addCloseButtonListener = () => {
  const element = document.querySelector(DRAWER_CLOSE_BUTTON_SELECTOR);

  const eventHandler = () => {
    sendPostAddToCartGTMEvent(GTM_LABEL_CLOSE_DRAWER_X);
  };

  element && element.addEventListener(CLICK_EVENT, eventHandler);
};
/**
 * Handle overlay Close event
 */


const addCloseOverlayListener = () => {
  const element = document.querySelector(DRAWER_CLOSE_OVERLAY_SELECTOR);

  const eventHandler = () => {
    sendPostAddToCartGTMEvent(GTM_LABEL_EXIT_DRAWER_OUTSIDE);
  };

  element && element.addEventListener(CLICK_EVENT, eventHandler);
};
/**
 * Handle product tile Click event
 */


const addProductTileClickListener = () => {
  const elements = document.querySelectorAll(PRODUCT_TILE_LINK_SELECTOR);

  const eventHandler = () => {
    sendPostAddToCartGTMEvent(GTM_LABEL_PRODUCT);
  };

  elements.forEach(element => element.addEventListener(CLICK_EVENT, eventHandler));
};
/**
 * Handle View Cart Click event
 */


const addViewCartClickListener = () => {
  /** @type {EventListener} */
  const viewCartEventHandler = function viewCartEventHandler(event) {
    const targetEl =
    /** @type {Element} */
    event.target;

    if (!targetEl.closest(VIEW_CART_SELECTOR)) {
      return;
    }

    sendPostAddToCartGTMEvent(GTM_LABEL_VIEW_CART);
  };

  document.addEventListener(CLICK_EVENT, viewCartEventHandler);
};
/**
 * Handle Check Out Click event
 */


const addCheckoutClickListener = () => {
  /** @type {EventListener} */
  const checkoutEventHandler = function checkoutEventHandler(event) {
    const targetEl =
    /** @type {Element} */
    event.target;

    if (!targetEl.closest(CHECKOUT_SELECTOR)) {
      return;
    }

    sendPostAddToCartGTMEvent(GTM_LABEL_CHECK_OUT);
  };

  document.addEventListener(CLICK_EVENT, checkoutEventHandler);
};
/**
 * Initialize module
 */


const init = () => {
  addCartListener();
  addCloseButtonListener();
  addCloseOverlayListener();
  addProductTileClickListener();
  addViewCartClickListener();
  addCheckoutClickListener();
};

/**
 * @typedef {object} PriceInformationProps
 *
 * Describes the expected prop types for the `PriceInformation` component.
 *
 * @property {number} itemQty
 * @property {import('../../product-json').Variant | undefined} variant
 * @property {boolean} [isMobile]
 * @property {boolean} shouldHideLimitedQuantityText
 */

/**
 * @param {PriceInformationProps} props
 */

const PriceInformation = ({
  itemQty,
  variant,
  isMobile,
  shouldHideLimitedQuantityText
}) => h("div", {
  class: "de-postAddToCart-pricerow de-postAddToCart-pricerow--" + (isMobile ? 'sm' : 'md') + " de-u-md-textGrow de-u-spaceBottom06"
}, variant && !variantHasSufficientQuantity(variant) && !shouldHideLimitedQuantityText && h("span", {
  class: "de-postAddToCart-inventoryNotice de-u-size2of6 de-u-textRed de-u-textMedium"
}, PRODUCT_PAGE_COPY.limitedQuantityLeft(variant.inventory_quantity)), h("div", {
  class: "de-postAddToCart-priceInfo de-u-sizeFull"
}, h("div", {
  class: "de-u-flex de-u-flexJustifyBetween de-u-sizeFull"
}, h("div", null, (variant == null ? void 0 : variant.price) && h("span", {
  class: "de-ProductTile-price de-u-padRight06 de-price",
  id: "ProductPrice"
}, h("span", {
  class: "de-u-hiddenVisually"
}, "Sale price:"), sessionStorage.getItem('isPriceSecondaryActive') == "true" && h("div", null, h("span", {
  class: "de-price"
}, formatPriceSingle(variant.price)), " ", h("span", {
  class: "price-secondary"
}, formatPriceSecondary(variant.price))), sessionStorage.getItem('isPriceSecondaryActive') == "false" && h("span", {
  class: "de-price"
}, formatPriceSingle(variant.price))), (variant == null ? void 0 : variant.compare_at_price) && h("span", null, h("del", null, h("span", {
  class: "de-u-hiddenVisually"
}, "Regular price:"), h("span", {
  class: "de-price"
}, formatPriceSingle(variant.compare_at_price)))) || null), itemQty > 0 && h("span", null, translate("Cantidad"), ": ", itemQty), itemQty > 0 && (variant == null ? void 0 : variant.price) && sessionStorage.getItem('isPriceSecondaryActive') == "true" && h("div", null, h("span", {
  class: "de-u-textMedium de-price"
}, formatPriceSingle(itemQty * variant.price)), h("span", {
  class: "de-price price-secondary"
}, formatPriceSecondary(itemQty * variant.price))), itemQty > 0 && (variant == null ? void 0 : variant.price) && sessionStorage.getItem('isPriceSecondaryActive') == "false" && h("span", {
  class: "de-u-textMedium de-price"
}, formatPriceSingle(itemQty * variant.price)))));

/**
 * @typedef {object} Props
 * @property {import('../../product-json').Variant | undefined} [variant]
 * @property {number} itemQty
 * @property {number} maxAllowedQuantity
 * @property {import('../../cart').Cart | undefined} [cart]
 * @property {boolean | undefined} [isCartBulky] Whether the cart has any bulky items
 * @property {boolean | undefined} [isProductBulky] Whether the product that was added is bulky
 * @property {string} productTitle
 * @property {boolean} [isAllShippingFree] Global shopify free shipping setting
 * @property {boolean} [isGraphOn] Graph enabled or not
 * @property {boolean} [isAjaxCartAddInProgress]
 * @property {string | undefined} [cartErrorText]
 * @property {boolean} shouldHideLimitedQuantityText
 * @property {boolean} [showFreeReturnsMessaging=true] Show the free returns messaging
 */

/**
 * UI component for the item that has been added to cart
 * @param {Props} props
 */
const CartItemInfo = ({
  variant,
  itemQty,
  maxAllowedQuantity,
  cart,
  isCartBulky,
  isProductBulky,
  isAllShippingFree = false,
  isGraphOn = false,
  productTitle,
  isAjaxCartAddInProgress = false,
  cartErrorText,
  shouldHideLimitedQuantityText,
  showFreeReturnsMessaging = true
}) => {
  const cartPrice = (cart == null ? void 0 : cart.total_price) || 0;
  return h("section", {
    class: "de-PostAddToCart-content de-PostAddToCart-info"
  }, h("section", {
    class: "de-CartItemInfo-grid de-u-padTop06 de-u-md-padEnds06"
  }, (variant == null ? void 0 : variant.featured_image) && h("div", {
    class: "de-CartItemInfo-images de-u-flex de-u-flexNone de-u-flexAlignItemsCenter"
  }, itemQty > 0 && h("div", {
    class: "de-u-flex de-u-padRight06"
  }, h("svg", {
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26"
  }, h("path", {
    d: "M8.56591313,23 L8.55915517,23 C8.25778143,22.9975013 7.96990825,22.8649608 7.75991373,22.632019 L0.326157411,14.3864291 C0.0411391726,14.0763895 -0.0674580557,13.6253338 0.0417364197,13.205094 C0.150930895,12.7848541 0.461103291,12.4601388 0.854091777,12.35465 C1.24708026,12.2491612 1.66237241,12.3791421 1.94176045,12.6950758 L8.5771764,20.057123 L24.0912006,3.34068829 C24.5331474,2.88074577 25.235644,2.8873236 25.6701063,3.35547236 C26.1045686,3.82362113 26.1106731,4.58058654 25.6838266,5.05680017 L9.36200085,22.6441556 C9.15091486,22.8718059 8.8645634,23 8.56591313,23 L8.56591313,23 Z",
    id: "Path",
    fill: "#0380C5",
    "fill-rule": "nonzero"
  }))), h("img", {
    alt: variant.featured_image.alt || 'Featured Image',
    class: "de-ProductThumbnail de-u-block",
    src: shopifyImgSize(variant.featured_image.src, 'x150')
  })), h("div", {
    class: "de-CartItemInfo-price de-u-padLeft03 de-u-sizeFull de-u-md-textGrow"
  }, h("h3", {
    class: "de-u-textGrow1 de-u-md-textGrow2 de-u-textMedium de-u-spaceBottomNone",
    itemProp: "name"
  }, productTitle), h("div", {
    class: "de-u-textDarkGray"
  }, h("span", {
    style: "font-family: avalonregular !important;"
  }, variant && variant.options.slice(0, -1).join(' | ')), h(PriceInformation, {
    itemQty: itemQty,
    variant: variant,
    shouldHideLimitedQuantityText: shouldHideLimitedQuantityText
  }))), cartErrorText && !isAjaxCartAddInProgress && h("span", {
    class: "de-CartItemInfo-message de-u-textRed de-u-textMedium de-u-lineHeight2 de-u-padLeft03 de-u-hidden de-u-lg-block"
  }, "(", translate("Cantidad en inventario: {{ stock}}. Por favor intenta tu orden nuevamente.", {
    stock: maxAllowedQuantity
  }), ")")), h(PriceInformation, {
    isMobile: true,
    itemQty: itemQty,
    variant: variant,
    shouldHideLimitedQuantityText: shouldHideLimitedQuantityText
  }), cartErrorText && !isAjaxCartAddInProgress && h("span", {
    class: "de-u-textRed de-u-textMedium de-u-padBottom06 de-u-lineHeight2 de-u-block de-u-lg-hidden de-u-borderBottomSm de-u-borderLightGray"
  }, cartErrorText), h(FreeShippingIndicator, {
    class: "de-u-hidden de-u-lg-block de-u-padBottomNone de-u-borderTopMd de-u-borderLightGray de-u-padEnds06 de-u-md-padBottom03",
    cart: cart,
    cartPrice: cartPrice,
    isCartBulky: isCartBulky,
    showLoadingState: isAjaxCartAddInProgress,
    isProductBulky: isProductBulky,
    isAllShippingFree: isAllShippingFree,
    isGraphOn: isGraphOn,
    showFreeReturnsMessaging: showFreeReturnsMessaging
  }));
};

/**
 * @property {import('../product-json').ProductJSON} product
 * @property {import('../product-json').Variant | undefined} variant
 */

const maxAllowedQuantityForAVariant = (product, variant) => {
  // console.log(product);
  // console.log(variant);
  //on place par defaut la valeur d'inventaire total
  if (variant == undefined) {
    return 0;
  } else {
    var maxAllowedQuantity = variant.inventory_quantity;
  } //on regarde si une limite a été trouvée dans les tags


  var strAChercher = "MAX_QUANTITY_SKU_" + variant.sku + ":";
  product.tags.forEach(tag => {
    if (tag.search(strAChercher) >= 0) {
      // on a trouvé le tag correspondant
      //quelle est la valeur max autorisée ?
      var tagLen = tag.length;
      var strLen = strAChercher.length;
      var quantity = parseInt(tag.substring(strLen, tagLen));
      maxAllowedQuantity = Math.min(maxAllowedQuantity, quantity);
    }
  }); // console.log("max quantity " + maxAllowedQuantity);

  return maxAllowedQuantity;
};
/** @typedef {import('../cart').Cart} Cart */

/**
 * @typedef {object} PostAddToCartProps
 *
 * Describes the expected prop types for the `PostAddToCartContent` component.
 *
 * @property {Cart | undefined} cart
 * @property {import('../product-json').ProductJSON} product
 * @property {import('../product-json').Variant | undefined} variant
 * @property {number} itemQty
 * @property {boolean} isAllShippingFree
 * @property {boolean} isGraphOn
 * @property {import('../shopify').CartDetailsCache | undefined} cartDetailsCache
 * @property {string | undefined} [cartErrorText]
 * @property {boolean} isAjaxCartAddInProgress Is the legacy AJAX ATC network request in progress?
 */

/**
 * This is a separate component so that we can test it by passing `cartItem` and `cart` in directly
 * @param {PostAddToCartProps} props
 */


const PostAddToCartContent = ({
  cart,
  product,
  variant,
  itemQty,
  cartDetailsCache,
  isAllShippingFree,
  isGraphOn,
  cartErrorText,
  isAjaxCartAddInProgress
}) => {
  /** Products with the `HIDE_ONLY_N_LEFT_TAG` should not render "Only X left" */
  const shouldHideLimitedQuantityText = product.tags.includes(HIDE_ONLY_N_LEFT_TAG);
  /** Whether product that was just added is "bulky" */

  const isProductBulky = product.tags.includes(PRODUCT_BULKY_TAG);
  /** Whether the cart contains any "bulky" items */

  const isCartBulky = cart == null ? void 0 : cart.items.some(item => {
    var _cartDetailsCache$ite;

    return cartDetailsCache == null ? void 0 : (_cartDetailsCache$ite = cartDetailsCache[item.key]) == null ? void 0 : _cartDetailsCache$ite.isBulky;
  });
  /** Products with NO_FREE_RETURNS tag should not show "returns" messaging  */

  const showFreeReturnsMessaging = !product.tags.includes(NO_FREE_RETURNS);
  const cartPrice = (cart == null ? void 0 : cart.total_price) || 0;
  const maxAllowedQuantity = maxAllowedQuantityForAVariant(product, variant);
  return h("section", {
    class: "de-PostAddToCart",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, h(CartItemInfo, {
    cart: cart,
    isCartBulky: isCartBulky,
    isProductBulky: isProductBulky,
    productTitle: product.title,
    variant: variant,
    maxAllowedQuantity: maxAllowedQuantity,
    itemQty: itemQty,
    cartErrorText: cartErrorText,
    isAllShippingFree: isAllShippingFree,
    isGraphOn: isGraphOn,
    isAjaxCartAddInProgress: isAjaxCartAddInProgress,
    shouldHideLimitedQuantityText: shouldHideLimitedQuantityText,
    showFreeReturnsMessaging: showFreeReturnsMessaging
  }), h(CartSubtotal, {
    class: "de-u-spaceTop de-u-lg-spaceTopNone",
    cart: cart,
    cartDetailsCache: cartDetailsCache,
    isCartBulky: isCartBulky,
    isAllShippingFree: isAllShippingFree,
    showLoadingState: isAjaxCartAddInProgress
  }), h(FreeShippingIndicator, {
    class: "de-u-borderTopMd de-u-borderLightGray de-u-padTop06 de-u-padBottomNone de-u-lg-hidden",
    cart: cart,
    cartPrice: cartPrice,
    isCartBulky: isCartBulky,
    isAllShippingFree: isAllShippingFree,
    isGraphOn: isGraphOn,
    showFreeReturnsMessaging: showFreeReturnsMessaging,
    showLoadingState: isAjaxCartAddInProgress
  }));
};
const PostAddToCart = () => {
  var _window$Shopify, _window$Shopify$cart, _window$DECATHLON_NAM, _window$DECATHLON_NAM2;

  /** Most recent cart that has been fetched successfully */
  const [cart, setCart] = v(
  /** @type {Cart | undefined} */
  undefined);
  const [cartDetailsCache, setCartDetailsCache] = v(
  /**
   * This is the pre-AJAX cart that is rendered on page load
   *
   * @NOTE The cart returned via AJAX does not contain all values
   * referenced in Shopify's Cart Object documentation.
   * For example, `line_item.product` is missing. The `product` Object is
   * required to to validate a "bulky" cart or not.
   * @see https://help.shopify.com/en/themes/liquid/objects/cart
   */
  (_window$Shopify = window.Shopify) == null ? void 0 : (_window$Shopify$cart = _window$Shopify.cart) == null ? void 0 : _window$Shopify$cart.detailsCache);
  /** Most recent product that has been added to cart */

  const [product, setProduct] = v(window.productJSON);
  /**
   * Handles obtaining item data from the window.productJSON object
   * based on variant ID in url
   */

  const urlVariant = getUrlVariant();
  /** The variant of the most recent product that has been added to cart */

  const [variant, setVariant] = v(product == null ? void 0 : product.variants.find(v => v.id === urlVariant));
  /** Most recent cart item(s) that has been added to cart by Product Tile ATC */

  const [addedCartItem, setAddedCartItem] = v(
  /** @type {import('../cart-item').CartItem | undefined} */
  undefined);
  /**
   * Most recent cart that was requested from ajax-cart.js
   * @type {Cart | undefined}
   */

  const ajaxCart = useCartEvent(CART_UPDATE_EVENT);
  /**
   * Whenever the AJAX cart gets updated, update the `cart` variable to match it, and
   * set the active product and variant
   */

  p(() => {
    var _window$productJSON;

    setProduct(window.productJSON);
    setVariant((_window$productJSON = window.productJSON) == null ? void 0 : _window$productJSON.variants.find(v => v.id === getUrlVariant()));
    setCart(ajaxCart);
  }, [ajaxCart]);
  /** @type {number} */

  const itemQty = useCartEvent('quantity') || 0;
  /** @type {boolean} */

  const isAjaxCartAddInProgress = useCartEvent('isAjaxCartAddInProgress') || false;
  /** @type {string | undefined} */

  const cartErrorText = useCartEvent('cartErrorText');
  /** @type {object | undefined} The line item added from successful Product Tile ATC action */

  const productTileItemsAdded = useCartEvent(PRODUCT_TILE_ADD_TO_CART_SUCCESS_EVENT);
  /** Retrieve cart to hold as a backup, if needed */

  p(() => {
    fetch('/cart.js').then(response => response.json()).then(setCart);
  }, []);
  /**
   * This allows the Product Tiles to _fake_ skeleton load themselves.
   * The `de-is-loading` classname is not applied initially on the product tiles
   * because of the race condition where the `isAjaxCartAddInProgress` event completes
   * prior to fetching of product tiles. This avoids the scenario of the async product tiles
   * getting stuck in a skeleton state.
   */

  p(() => {
    const loadingCssClass = 'de-is-loading';
    const skeletonProductTileEls = document.querySelectorAll('.js-de-PostAddToCart-featuredProducts .js-de-Skeleton');

    if (isAjaxCartAddInProgress || !cart) {
      // Add skeleton product tiles
      skeletonProductTileEls.forEach(el => el.classList.add(loadingCssClass));
    } else {
      // Remove skeleton product tiles
      skeletonProductTileEls.forEach(el => el.classList.remove(loadingCssClass));
    }
  }, [cart, isAjaxCartAddInProgress]);
  const isAllShippingFree = ((_window$DECATHLON_NAM = window[DECATHLON_NAMESPACE]) == null ? void 0 : _window$DECATHLON_NAM.isAllShippingFree) || false;
  const isGraphOn = ((_window$DECATHLON_NAM2 = window[DECATHLON_NAMESPACE]) == null ? void 0 : _window$DECATHLON_NAM2.isGraphOn) || false;
  /**
   * When an AJAX cart error occurs, set the PAC cart product details to the
   * page's currently selected product variant. This is necessary when a user
   * attempts to ATC from a product tile in PAC, the request fails, then the user
   * tries to ATC again from buybox. Without clearing this global error state, a
   * variant added from buybox will not be correctly displayed in PAC details.
   */

  p(() => {
    var _window$productJSON2;

    if (!cartErrorText) return;
    setProduct(window.productJSON);
    setVariant((_window$productJSON2 = window.productJSON) == null ? void 0 : _window$productJSON2.variants.find(v => v.id === getUrlVariant()));
  }, [cartErrorText]);
  /**
   * Handles the Add to Cart event on a product tile. Sets the added cart item to be referenced,
   * and fetches the cart that contains the newly added item.
   */

  p(() => {
    var _productTileItemsAdde, _productTileItemsAdde2;

    setAddedCartItem(productTileItemsAdded == null ? void 0 : (_productTileItemsAdde = productTileItemsAdded.addedProduct) == null ? void 0 : (_productTileItemsAdde2 = _productTileItemsAdde.items) == null ? void 0 : _productTileItemsAdde2[0]);

    const getAndSetCart = async () => {
      const fetchedCart = await getCart();
      setCart(fetchedCart);
    };

    getAndSetCart();
  }, [productTileItemsAdded]);
  /**
   * Adds AJAX product attributes to `cartDetailsCache`
   */

  p(() => {
    cart == null ? void 0 : cart.items.forEach(async item => {
      if (cartDetailsCache == null ? void 0 : cartDetailsCache[item.key]) return;
      setCartDetailsCache(cartDetailsCache => Object.assign({}, cartDetailsCache, {
        // We are setting it to an empty object so that it does not get re-fetched
        // if the useEffect gets called before the api response comes back
        [item.key]: {}
      }));
      const cartItemProduct = await getProduct(item.handle);
      if (!cartItemProduct) return;
      const cartItemVariant = cartItemProduct.variants.find(v => v.id === item.id);
      setCartDetailsCache(cartDetailsCache => Object.assign({}, cartDetailsCache, {
        [item.key]: {
          compareAtPrice: cartItemVariant == null ? void 0 : cartItemVariant.compare_at_price,
          isBulky: cartItemProduct.tags.includes(PRODUCT_BULKY_TAG),
          product: cartItemProduct,
          selectedVariant: cartItemVariant
        }
      }));
    });
  }, [cart, cartDetailsCache]);
  /**
   * Sets the newly added product and selected variant
   */

  p(() => {
    if (!addedCartItem) return;
    const cartItem = cartDetailsCache == null ? void 0 : cartDetailsCache[addedCartItem == null ? void 0 : addedCartItem.key];
    if (!(cartItem == null ? void 0 : cartItem.product)) return;
    setProduct(cartItem.product);
    setVariant(cartItem.selectedVariant);
    /**
     * Clears the last added cart item to ensure that when PAC is opened again,
     * a product previously added from a tile will not be re-rendered in PAC
     * details (cart-item-info).
     * @TODO Consider if this file needs its own listener for
     * 'PRODUCT_TILE_ADD_TO_CART_FAILURE_EVENT'.
     */

    setAddedCartItem(undefined); // Ensures the "Great Choice!" messaging reflects a successfully added cart item

    cartEventEmitter.emit('cartErrorText', '');
  }, [cartDetailsCache, addedCartItem]);
  return h(PostAddToCartContent, {
    cart: cart,
    product: product,
    variant: variant,
    itemQty: itemQty,
    cartDetailsCache: cartDetailsCache,
    isAllShippingFree: isAllShippingFree,
    isGraphOn: isGraphOn,
    cartErrorText: cartErrorText,
    isAjaxCartAddInProgress: isAjaxCartAddInProgress
  });
};
/**
 * @template T
 * @param {string} eventName The event name to listen for on cartEventEmitter
 * Listens for a mitt event to fire on cartEventEmitter
 * @returns the most recent value that the event fired with.
 */

const useCartEvent = eventName => {
  const [value, setValue] = v(
  /** @type {T | undefined} */
  undefined);
  p(() => {
    /** @param {T} data */
    const listener = data => {
      setValue(data);
    };

    cartEventEmitter.on(eventName, listener);
    return () => cartEventEmitter.off(eventName, listener);
  }, [eventName]);
  return value;
};

var _window$DY;
const rootEl = document.querySelector("." + JS_PREFIX + "PAC-dynamic-content");
if (rootEl) E(h(PostAddToCart, null), rootEl); // Initialize PAC-specific analytics

init();
/**
 * Wait for DY to be ready
 *
 * @see https://support.dynamicyield.com/hc/en-us/articles/360007232477-Wait-for-Element-Client-Side-APIs#wait-for-dynamic-yield-script-0-3
 *
 * Initializes the Dynamic Yield product tile grid for PAC
 */

(_window$DY = window.DY) == null ? void 0 : _window$DY.API == null ? void 0 : _window$DY.API('callback', () => {
  document.querySelectorAll("." + JS_PREFIX + "DYProductTileGrid").forEach(dyProductTileGridEl => {
    // Using a try/catch with console.error allows subsequent widgets to still
    // initialize even if the first one errors out
    try {
      init$1("#" + dyProductTileGridEl.id);
    } catch (error) {
      console.error(error);
    }
  });
});
